import attachGalleryModalHandlers from "../../resources/js/modules/modal";
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

let downloadSlider;

window.addEventListener('load', () => {
    toggleDropdown();
    loadMore();
    changeFilter();
    reinitGallery();
    initSwiper();
    initMediaKit();
    reinitDownloads();
});

function toggleDropdown() {
    const dropdowns = document.querySelectorAll('[data-filter-js]');

    dropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('[data-filter-trigger-js]');
        if (!trigger) return;

        trigger.addEventListener('click', (e) => {
            // stop other dropdowns
            dropdowns.forEach(d => {
                if (d !== dropdown) {
                    d.classList.remove('active');
                }
            });
            dropdown.classList.toggle('active');
            e.stopPropagation();
        });
    });

    // Close dropdowns when clicking outside any dropdown
    document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-filter-js]')) {
            dropdowns.forEach(d => d.classList.remove('active'));
        }
    });
}

function loadMore() {
    const section = document.querySelector('.gallery-section');
    const loadMoreBtn = section.querySelector('[data-load-more-js]');
    const spinner = document.querySelector('[data-spinner-js]');

    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', async () => {
        const galleryGrid = section.querySelector('[data-gallery-js]');
        const currentPage = parseInt(galleryGrid.dataset.page);
        const perPage = parseInt(galleryGrid.dataset.perPage);
        const productType = section.querySelector('[data-filter-group="product-type"] .filter-current').dataset.value;
        const productSeries = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.value;
        const productSeriesType = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.series;
        spinner.classList.add('active');

        fetch(themeVars.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'filter_product_gallery',
                page: currentPage + 1,
                per_page: perPage,
                product_type: productType,
                product_series: productSeries,
                product_series_type: productSeriesType ? productSeriesType : '',
            }),
        }).then(r => r.json()).then(res => {
            if (res.success && res.data.html) {

                galleryGrid.insertAdjacentHTML('beforeend', res.data.html);
                galleryGrid.dataset.page = currentPage + 1;
                
                if (currentPage + 1 >= res.data.max_pages) {
                    loadMoreBtn.style.display = 'none';
                    spinner.classList.remove('active');
                }
                attachGalleryModalHandlers();
            } else {
                loadMoreBtn.style.display = 'none';
                spinner.classList.remove('active');
            }
        });
    });
}

function reinitGallery() {
    const section = document.querySelector('.gallery-section');
    const triggers = section.querySelectorAll('[data-filter-trigger-js] .filter-current');
    const loadMoreBtn = section.querySelector('[data-load-more-js]');
    const spinner = document.querySelector('[data-spinner-js]');
    
    triggers.forEach(trigger => {
        trigger.addEventListener('update', () => {
            const galleryGrid = section.querySelector('[data-gallery-js]');
            const perPage = parseInt(galleryGrid.dataset.perPage);
            const productType = section.querySelector('[data-filter-group="product-type"] .filter-current').dataset.value;
            const productSeries = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.value;
            const productSeriesType = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.series;
            spinner.classList.add('active');

            fetch(themeVars.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'filter_product_gallery',
                    page: 1,
                    per_page: perPage,
                    product_type: productType,
                    product_series: productSeries,
                    product_series_type: productSeriesType ? productSeriesType : '',
                }),
            }).then(r => r.json()).then(res => {
                if (res.success && res.data.html) {
                    galleryGrid.innerHTML = res.data.html;
                    galleryGrid.dataset.page = 1;
                    
                    if (1 >= res.data.max_pages) {
                        loadMoreBtn.style.display = 'none';
                    } else {
                        loadMoreBtn.style.display = 'block';
                    }
                    attachGalleryModalHandlers();
                }
                else {
                    galleryGrid.innerHTML = '';
                }
                spinner.classList.remove('active');
            });
        });
    });
}

function reinitDownloads() {
    const section = document.querySelector('.downloads-section');
    const triggers = section.querySelectorAll('[data-filter-trigger-js] .filter-current');
    const spinner = document.querySelector('[data-spinner-js]');

    triggers.forEach(trigger => {
        trigger.addEventListener('update', () => {
            const swiperWrapper = section.querySelector('[data-downloads-container-js]');
            const informationType = section.querySelector('[data-filter-group="information-type"] .filter-current').dataset.value;
            const productType = section.querySelector('[data-filter-group="product-type"] .filter-current').dataset.value;
            const productSeries = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.value;
            const productSeriesType = section.querySelector('[data-filter-group="product-series"] .filter-current').dataset.series;
            spinner.classList.add('active');

            fetch(themeVars.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'filter_product_downloads',
                    information_type: informationType,
                    product_type: productType,
                    product_series: productSeries,
                    product_series_type: productSeriesType ? productSeriesType : '',
                }),
            }).then(r => r.json()).then(res => {
                if (res.success && res.data.html) {
                    swiperWrapper.innerHTML = res.data.html;
                    initSwiper();
                }
                else {
                    console.log(res);
                }
                spinner.classList.remove('active');
            });
        });
    });
}

function changeFilter() {
    const dropdowns = document.querySelectorAll('[data-filter-js]');

    dropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('[data-filter-trigger-js] .filter-current');
        const options = dropdown.querySelectorAll('[data-filter-ul-js] .option');

        options.forEach(option => {
            if (!option) return;
            const button = option.querySelector('button');
            if (!button) return;
            
            button.addEventListener('click', () => {
                trigger.textContent = button.textContent;
                trigger.dataset.value = option.dataset.value;
                trigger.dataset.series = option.dataset.series || '';
                // mark selected
                dropdown.querySelectorAll('.option').forEach(o => o.classList.remove('filter-current'));
                option.classList.add('filter-current');
                // dispatch custom event so other parts can react to value change
                const ev = new CustomEvent('update', { detail: { value: option.dataset.value } });
                trigger.dispatchEvent(ev);
                if (option.dataset.series) {
                    const seriesEv = new CustomEvent('update', { detail: { series: option.dataset.series } });
                    trigger.dispatchEvent(seriesEv);
                }
                dropdown.classList.remove('active');
            });
        });
    });
}

function initSwiper() {
    const blocks = document.querySelector('.downloads-section');

    if (!blocks) return;
    downloadSlider?.destroy(true, true);

    const container = blocks.querySelector('.swiper');
    if (!container) return;

    const swiper = new Swiper(container, {
        modules: [Navigation],
        spaceBetween: '1px',
        slidesPerView: 1,
        navigation: {
            nextEl: blocks.querySelector('.swiper-button-next'),
            prevEl: blocks.querySelector('.swiper-button-prev'),
        },
    });

    downloadSlider = swiper;
}

function initMediaKit() {
    const blocks = document.querySelector('.media-section');

    if (!blocks) return;

    const container = blocks.querySelector('.swiper');
    if (!container) return;

    const swiper = new Swiper(container, {
        modules: [Navigation],
        spaceBetween: '1px',
        slidesPerView: 1,
        navigation: {
            nextEl: blocks.querySelector('.swiper-button-next'),
            prevEl: blocks.querySelector('.swiper-button-prev'),
        },
    });

    swiper;
}
